import { useMetaTags } from 'react-metatags-hook';
import { MetaTagsConfig } from 'react-metatags-hook/dist/cjs/types';
import { buildPublicUrl } from './buildUrl';

const DEFAULT_TITLE = 'Ищите новые идеи от любимых брендов по картинкам — Яндекс Ритм';

const DEFAULT_EXTERNAL_TITLE = 'Яндекс Ритм';

const DEFAULT_DESCRIPTION = `Ритм позволяет следить за любимыми брендами или просто искать вдохновение — например, идеи для стиля или для ремонта в квартире.

Чтобы купить товар «как на картинке», больше не нужно искать в интернете — достаточно перейти по ссылке в посте. Находите идеи и товары по темам, которые вам интересны, от моды до спорта.`;

export const useMeta = (config: MetaTagsConfig = {}, dependencies: unknown[] = []) =>
    useMetaTags(
        {
            title: config.title ?? DEFAULT_TITLE,
            description: config.description ?? DEFAULT_DESCRIPTION,
            openGraph: {
                site_name: DEFAULT_EXTERNAL_TITLE,
                title: config.openGraph?.title ?? config.title ?? DEFAULT_EXTERNAL_TITLE,
                image: config.openGraph?.image ?? buildPublicUrl('/images/og-image.png'),
                description:
                    config.openGraph?.description ?? config.description ?? DEFAULT_DESCRIPTION,
            },
            twitter: {
                card: 'summary_large_image',
                title:
                    config.twitter?.title ??
                    config.openGraph?.title ??
                    config.title ??
                    DEFAULT_EXTERNAL_TITLE,
                description:
                    config.twitter?.description ??
                    config.openGraph?.description ??
                    config.description ??
                    DEFAULT_DESCRIPTION,
                image:
                    config.twitter?.image ??
                    config.openGraph?.image ??
                    buildPublicUrl('/images/og-image.png'),
            },
            links: config.links,
        },
        dependencies,
    );
